<app-dev-panel *ngIf="!isInspectMode"></app-dev-panel>
<div id="audio-elements" hidden></div>
<section #applicationContent class="section-container">
  <div
    class="app-content"
    [class.presentation-content]="router.url.includes('/present')"
    [class.authenticated-content]="authService.firebaseUser | async"
    [class.unauthenticated-content]="(authService.firebaseUser | async) === null"
    [class.practice-content]="router.url.includes('/practice')"
  >
    <div
      class="sidebar collapsed d-flex flex-column justify-content-between align-items-center"
      *ngIf="(authService.firebaseUser | async) && router.url.includes('/present')"
    >
      <div class="d-flex flex-column align-items-center">
        <button class="logo" routerLink="/">
          <app-logo> </app-logo>
        </button>
        <button routerLink="/content">
          <app-pencil-icon name="house" [type]="IconTypes.lucideIcon"></app-pencil-icon>
        </button>
        <button
          *ngIf="user && (user | has: Features.view_schedule_page)"
          routerLink="/schedule"
          [ngClass]="{ active: router.url.includes('/schedule') }"
        >
          <app-pencil-icon name="calendar" [type]="IconTypes.lucideIcon"></app-pencil-icon>
        </button>
        <button>
          <app-pencil-icon name="ellipsis" [type]="IconTypes.lucideIcon"></app-pencil-icon>
        </button>
      </div>
    </div>
    <mat-sidenav-container class="app-content-sidenav-container" autosize>
      <mat-sidenav
        #appAside
        *ngIf="sidenavViewport$ | async as viewport"
        class="app-nav-sidenav"
        [class.app-nav-sidenav--non-desktop]="!viewport.isDesktop"
        [mode]="viewport.isDesktop ? 'side' : 'over'"
        [position]="(userService.rtl | async) ? 'end' : 'start'"
        [opened]="navService.isMenuOpened | async"
        [disableClose]="viewport.isDesktop"
        (closedStart)="navService.isMenuOpened.next(false)"
      >
        <app-switcher *ngIf="viewport.isDesktop"></app-switcher>
        <ui-nav-bar class="sidebar"></ui-nav-bar>
      </mat-sidenav>
      <mat-sidenav-content>
        <div
          class="content-container"
          [class.public-landing-view]="questionsService.isPublicQuestionView | async"
        >
          <app-top-bar
            *ngIf="topBar$ | async as topBar"
            [variant]="topBar.variant"
            [title]="topBar.title ? (topBar.title | translate) : ''"
          ></app-top-bar>
          <ui-header
            class="border-bottom"
            [class.sidebar-closed]="(navService.isMenuOpened | async) === false"
            *ngIf="
              (authService.firebaseUser | async) &&
              !router.url.includes('/account') &&
              router.url !== '/' &&
              !router.url.includes('/content/course/questions') &&
              !router.url.includes('/content/course/notes') &&
              !router.url.includes('/content/course/lessons') &&
              !router.url.includes('/content/worksheets/list') &&
              !router.url.includes('/create') &&
              !router.url.includes('/present') &&
              !router.url.includes('/view') &&
              !router.url.includes('/practice') &&
              !router.url.includes('/' + URL_CONSTANTS.SPACES) &&
              !router.url.includes('/' + URL_CONSTANTS.HOME) &&
              !router.url.includes('/pencilcam') &&
              !router.url.includes('/techcheck') &&
              !router.url.includes('/next') &&
              (router.url.includes('analytics/recordings') || !router.url.includes('/recording')) &&
              !hidesNavForSessionDetails
            "
          >
            <div
              class="position-relative flex-1"
              [ngClass]="{
                'h-100':
                  router.url.includes('/content/worksheets') ||
                  router.url.includes('/notifications') ||
                  router.url.includes('/course/settings')
              }"
            >
              <div
                class="m-0 font-24 d-flex align-items-center"
                [ngClass]="{
                  marginTop:
                    router.url.includes('/content/worksheets') ||
                    router.url.includes('/notifications')
                }"
              >
                <app-pencil-icon
                  class="curren-url-icon cmr-8"
                  *ngIf="currentUrlIcon"
                  [name]="currentUrlIcon"
                  [type]="currentUrlIconType"
                ></app-pencil-icon>
                <span
                  class="material-icons go-back-arrow"
                  *ngIf="router.url.includes('/course/settings')"
                  routerLink="/content/course/questions/{{
                    questionsService.selectedCourseId | async
                  }}"
                >
                  arrow_back
                </span>
                <span>{{ (navService.headerTitle | async) || '' | translate }}</span>
              </div>
              <nav
                class="navbar navbar-expand-lg cp-0 d-none d-sm-block"
                *ngIf="router.url.includes('/notifications')"
                [attr.aria-label]="'notifications page navbar' | translate"
              >
                <ul class="navbar-nav flex-row">
                  <li
                    class="nav-item"
                    [class.active]="!router.url.includes('tab') || router.url.includes('all')"
                  >
                    <a
                      class="nav-link"
                      [queryParams]="{ tab: 'all' }"
                      routerLink="/notifications"
                      >{{ 'All' | translate }}</a
                    >
                  </li>
                  <li class="nav-item" [class.active]="router.url.includes('unread')">
                    <a
                      class="nav-link"
                      routerLink="/notifications"
                      [queryParams]="{ tab: 'unread' }"
                      >{{ 'Unread' | translate }}</a
                    >
                  </li>
                </ul>
              </nav>
              <nav
                class="navbar navbar-expand-lg cp-0 d-none d-sm-block"
                *ngIf="router.url.includes('/course/settings')"
                [attr.aria-label]="'course settings page navbar' | translate"
              >
                <ul class="navbar-nav flex-row">
                  <li class="nav-item" [class.active]="router.url.includes('details')">
                    <a
                      routerLink="content/course/settings/{{
                        questionsService.selectedCourseId | async
                      }}/details"
                      class="nav-link"
                      >{{ 'Details' | translate }}</a
                    >
                  </li>
                  <li class="nav-item" [class.active]="router.url.includes('people')">
                    <a
                      routerLink="content/course/settings/{{
                        questionsService.selectedCourseId | async
                      }}/people"
                      class="nav-link"
                      >{{ 'People' | translate }}</a
                    >
                  </li>
                  <li class="nav-item" [class.active]="router.url.includes('topics')">
                    <a
                      routerLink="content/course/settings/{{
                        questionsService.selectedCourseId | async
                      }}/topics"
                      class="nav-link"
                      >{{ 'Topics' | translate }}</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
            <div ui-header-actions>
              <button
                mat-flat-button
                class="btn-practice d-sm-inline-block d-none"
                color="primary"
                *ngIf="
                  router.url.includes('/content/worksheets/list') && user && !(user | isStudent)
                "
                (click)="questionsService.addSet.next(true)"
              >
                <span class="material-icons">add</span>
                <span>{{ 'Create set' | translate }}</span>
              </button>
              <app-pencil-button
                *ngIf="
                  router.url.includes('/profiles') &&
                  ((userService.user | async)?.user | has: Features.create_user)
                "
                theme="primary"
                (clickEvent)="profilesService.inviteUser.next(true)"
                data-name="header-profiles-invite-user"
                icon="person_add"
                [iconConfig]="{
                  type: 'material-icon'
                }"
                [label]="'Invite' | translate"
              >
              </app-pencil-button>
              <button
                mat-flat-button
                class="btn-practice d-sm-inline-block d-none cpx-12"
                color="primary"
                *ngIf="
                  router.url.includes('/course/settings') &&
                  router.url.includes('/people') &&
                  ((userService.user | async)?.user | has: Features.add_user_to_course)
                "
                routerLink="/content/course/settings/{{
                  questionsService.selectedCourseId | async
                }}/people"
                [queryParams]="{ add: true }"
              >
                <span class="material-icons">add</span>
                <span class="text-capitalize">{{ 'Add People' | translate }}</span>
              </button>
              <div
                appUpgradePlanBlocker
                [upgradePlanEvaluationType]="planEvaluationTypes.SELF"
                [options]="{
                  arrow: 'top',
                  placement: 'bottom'
                }"
              >
                <app-pencil-button
                  *ngIf="
                    router.url.includes('/schedule') &&
                    ((userService.user | async)?.user | has: Features.schedule_event)
                  "
                  theme="primary"
                  (clickEvent)="eventService.openCreateNewEvent()"
                  data-name="header-schedule-create-event"
                  icon="add"
                  [iconConfig]="{
                    type: 'material-icon'
                  }"
                  [label]="'Create Event' | translate"
                  [disabled]="isFreeUser"
                >
                </app-pencil-button>
              </div>
              <app-pencil-button
                *ngIf="router.url.includes('/messages')"
                theme="primary"
                (clickEvent)="openNewMessageDialog()"
                data-name="header-messages-create"
                icon="add"
                [iconConfig]="{
                  type: 'material-icon'
                }"
                [label]="'New message' | translate"
              >
              </app-pencil-button>
              <div
                *ngIf="router.url | isFileView"
                class="cmr-16"
                appTooltip="Your role does not allow this operation"
                [appTooltipDisabled]="
                  (userService.user | async)?.user | has: Features.upload_resource
                "
              >
                <app-pencil-button
                  theme="secondary-outline"
                  (clickEvent)="resourceService.createFolderIntent.next()"
                  data-name="header-files-create-folder"
                  icon="folder_plus"
                  [iconConfig]="{
                    type: 'lucide-icon'
                  }"
                  [label]="'New Folder' | translate"
                  [disabled]="!((userService.user | async)?.user | has: Features.upload_resource)"
                  buttonType="button"
                >
                </app-pencil-button>
              </div>
              <div
                appTooltip="Your role does not allow this operation"
                [appTooltipDisabled]="
                  (userService.user | async)?.user | has: Features.upload_resource
                "
              >
                <app-pencil-button
                  *ngIf="router.url | isFileView"
                  theme="primary"
                  (clickEvent)="resourceService.createResourceIntent.next(true)"
                  data-name="header-files-upload"
                  icon="file_upload"
                  [iconConfig]="{
                    type: 'material-icon'
                  }"
                  [label]="'Upload' | translate"
                  [disabled]="!((userService.user | async)?.user | has: Features.upload_resource)"
                >
                </app-pencil-button>
              </div>
              <app-pencil-button
                *ngIf="router.url === '/content' && (user | has: Features.create_course)"
                theme="primary"
                routerLink="/content/course/new"
                data-name="header-courses-create"
                icon="add"
                [iconConfig]="{
                  type: 'material-icon'
                }"
                [label]="'Create Course' | translate"
              >
              </app-pencil-button>
              <app-notifications-menu
                *ngIf="user && showNotificationBell"
                [user]="user"
              ></app-notifications-menu>
              <app-profile-photo
                class="cml-16 cursor-pointer"
                width="26"
                [class.has-nav]="router.url.includes('/content/worksheets')"
                [showStatus]="true"
                [hasMenu]="true"
                [isClickEnabled]="false"
              ></app-profile-photo>
            </div>
          </ui-header>
          <div class="content">
            <router-outlet></router-outlet>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
  <!-- Dynamic gadgets container for lazy-loaded components -->
  <ng-container #dynamicGadgets></ng-container>
  <ng-container *ngIf="appLoading || (showLoginFlowLoader | async)">
    <app-loading-v2 [fullParent]="true"></app-loading-v2>
  </ng-container>
</section>
